import setup from './moduleSetup';

export default {
    name: 'settings',
    before: [],
    after: [],
    setup,
};
